import { render, staticRenderFns } from "./ErrorAccount.vue?vue&type=template&id=99bfe2ca&scoped=true&"
import script from "./ErrorAccount.vue?vue&type=script&lang=js&"
export * from "./ErrorAccount.vue?vue&type=script&lang=js&"
import style0 from "./ErrorAccount.vue?vue&type=style&index=0&id=99bfe2ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99bfe2ca",
  null
  
)

export default component.exports